import script from "./TempB.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempB.vue?vue&type=script&lang=ts&setup=true"

import "./TempB.vue?vue&type=style&index=0&id=342a4bfc&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342a4bfc"]])

export default __exports__